// Quanto tempo o cliente está esperando. É o dado que decide quem atender
// primeiro numa fila, e era justamente o que a lista não mostrava.
//
// A cor sobe junto com a espera: sem cor até 5 minutos (nada acontecendo),
// e daí em diante cada faixa é um aviso mais forte. Só o tempo recebe cor
// na linha — canal e conexão são identidade, não urgência.
const FAIXAS = [
  { ateMinutos: 5, classe: "text-muted-foreground" },
  { ateMinutos: 15, classe: "text-sky-600 dark:text-sky-400" },
  { ateMinutos: 60, classe: "text-amber-600 dark:text-amber-400" },
  { ateMinutos: Infinity, classe: "text-rose-600 dark:text-rose-400" },
];

export const minutosDesde = (data) => {
  if (!data) return 0;

  return Math.max(
    0,
    Math.floor((Date.now() - new Date(data).getTime()) / 60000),
  );
};

export const formatarEspera = (minutos) => {
  if (minutos < 1) return "agora";
  if (minutos < 60) return `${minutos} min`;

  const horas = Math.floor(minutos / 60);

  if (horas < 24) {
    const resto = minutos % 60;
    return resto ? `${horas}h ${resto}min` : `${horas}h`;
  }

  const dias = Math.floor(horas / 24);

  return dias === 1 ? "1 dia" : `${dias} dias`;
};

export const classeDaEspera = (minutos) =>
  FAIXAS.find((f) => minutos < f.ateMinutos).classe;

// Só faz sentido cobrar espera de quem ainda não foi atendido; num ticket
// em andamento o relógio não é uma dívida.
export const esperaDoTicket = (ticket) => {
  if (!ticket || ticket.status === "closed") return null;

  const minutos = minutosDesde(ticket.updatedAt);

  return {
    minutos,
    rotulo: formatarEspera(minutos),
    classe:
      ticket.status === "pending"
        ? classeDaEspera(minutos)
        : "text-muted-foreground",
  };
};
